<h1>{{ 'Turbo.OneWayAdmin.FindBookingDialog.Headline' | translate : 'Find booking' }}</h1>

<div style="width: 400px;" class="turboContainer">
    <mat-form-field style="width: 100%;">
        <input matInput [formControl]="txtKeywords" placeholder="{{'Turbo.OneWayAdmin.FindBookingDialog.txtKeywords' | translate : 'Enter booking id or customer'}}" />
    </mat-form-field>
</div>
<div style="width: 400px; margin-top: 15px;" class="turboContainer">
    <div *ngIf="!bookings">{{'Turbo.OneWayAdmin.FindBookingDialog.msgNoBookings' | translate : 'No bookings has been found'}}</div>
    <div *ngIf="bookings" style="height: 250px; overflow: auto;">
        <div *ngFor="let item of bookings" class="list-item" (click)="showBooking(item.Id)">
            <div class="col-xs-4"><t4-booking-link [bookingId]="item.Id"></t4-booking-link></div>
            <div class="col-xs-4" style="text-align: right"><t4-customer-link [customerId]="item.Customer?.Id"></t4-customer-link></div>
            <div class="col-xs-4" style="text-align: center">{{ 'Turbo.Core.bookingTooltip.Status_' + item.Status | translate }}</div>
            <div class="col-xs-6"><t4-location-link [locationId]="item.PickupLocation?.Id">{{item.PickupLocation?.City}}</t4-location-link></div>
            <div class="col-xs-6">{{ item.PickupTime | date : 'yyyy-MM-dd HH:mm' }}</div>
            <div class="col-xs-6" style="text-align: right">{{ item.ReturnTime | date : 'yyyy-MM-dd HH:mm' }}</div>
        </div>
    </div>
    <div class="loader" *ngIf="loading.dialog">
        <div class="message">{{ loadingMessageKey | translate : loadingMessageDefault }}</div>
        <mat-progress-bar mode="indeterminate" style="width: 100%; bottom: 0;" *ngIf="loading.dialog"></mat-progress-bar>
    </div>
</div>
